import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { AwsApiWrapperService, BsCacheService } from '@brightside-web/desktop/data-access/core-services';
import { MobileStateService } from './mobile-state.service';
import { map } from 'rxjs/operators';
import { ApiResponse, AvailabilityHours, FullSsnRequest, RequiredVerification } from './api-contracts';

@Injectable({
  providedIn: 'root',
})
export class FullSsnService {
  private _awsAPIWrapper: AwsApiWrapperService = inject(AwsApiWrapperService);
  private _bsCacheService: BsCacheService = inject(BsCacheService);

  constructor(private mobile: MobileStateService) {}

  submitFullSsn(payload: FullSsnRequest): Observable<ApiResponse> {
    payload.ssn = payload.ssn.replace(/[^0-9]/gi, '');
    return from(this._awsAPIWrapper.put('api-mobile', '/client', { body: payload }));
  }

  createClientEvent() {
    this._awsAPIWrapper.post('api-mobile', '/client/event', { body: { type: 'collectSsnError' } });
  }

  getAvailability(): Observable<AvailabilityHours | null> {
    return this.mobile.get().pipe(
      map((ms) => {
        if (ms && ms.availability) {
          this._bsCacheService.setItem('availability', ms.availability);
          return ms.availability;
        } else {
          return null;
        }
      })
    );
  }

  getRequiredVerification(): Observable<RequiredVerification | null> {
    return this.mobile.get().pipe(
      map((mobileState) => {
        if (mobileState && mobileState.requiredVerification?.fullSsn?.last4) {
          this._bsCacheService.setItem('last4ssn', mobileState.requiredVerification.fullSsn?.last4);
          return mobileState.requiredVerification;
        } else {
          return null;
        }
      })
    );
  }
}
